import { eventInstant, eventLocal } from '../pages/competitions/leagueDateTime';

export class AvailabilityTimeError extends Error {}

export function availabilityTimezone(timezone?: string | null): string {
  const zone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: zone });
    return zone;
  } catch {
    throw new AvailabilityTimeError('The studio timezone is unavailable. Check the studio settings.');
  }
}

export function availabilityInput(instant: string, timezone?: string | null): string {
  return eventLocal(instant, availabilityTimezone(timezone));
}

export function oneTimeAvailability(startsAt: string, endsAt: string, timezone?: string | null) {
  const zone = availabilityTimezone(timezone);
  let start: string;
  let end: string;
  try {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(startsAt) || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(endsAt)) {
      throw new Error('Invalid wall time');
    }
    start = eventInstant(startsAt, zone);
    end = eventInstant(endsAt, zone);
  } catch {
    throw new AvailabilityTimeError('Choose valid times in the studio timezone. Daylight-saving gaps and repeated hours cannot be used.');
  }
  if (Date.parse(end) <= Date.parse(start)) {
    throw new AvailabilityTimeError('End must be after start.');
  }
  return { startsAt: start, endsAt: end };
}

export function availabilityDisplay(instant: string, timezone?: string | null): string {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: availabilityTimezone(timezone), month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
  }).format(new Date(instant));
}
